import { combineRules } from 'fela';

import type { TRuleWithTheme } from '@/styles/theme';

export const menuDefault: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',

    paddingTop: '1.5rem',
    paddingRight: '1.5rem',
    paddingBottom: '1.5rem',
    paddingLeft: '1.5rem',

    backgroundColor: theme.colors.white,

    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderRightColor: theme.colors.foregroundsSeparator,

    MsOverflowStyle: 'none',
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
        display: 'block',

        width: 0,
    },
});

export const menuDesktop: TRuleWithTheme = ({ theme }) => ({
    flexBasis: theme.widths.menu,
    flexGrow: 0,
    position: 'relative',
    flexShrink: 0,
});

export const menu = combineRules(menuDefault, menuDesktop);

// Stretches the shell's single content wrapper so children can pin themselves
// to the sidebar bottom with `marginTop: auto`.
export const menuContent: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
});

// Aligns the logo with the nav items' icons (8px gutter + 12px padding).
export const logoWrapper: TRuleWithTheme = ({ theme }) => ({
    marginBottom: theme.spacing(24),
    marginLeft: '-1rem',
    paddingLeft: theme.spacing(12),
});
